import { render, staticRenderFns } from "./addjob.vue?vue&type=template&id=15febc6a&scoped=true"
import script from "./addjob.vue?vue&type=script&lang=js"
export * from "./addjob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15febc6a",
  null
  
)

export default component.exports